import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, FormGroup } from '@angular/forms';
import { User } from 'src/app/shared/models/users';
import { Subscription } from 'rxjs';
import { Company } from 'src/app/shared/models/companies';
import { DetailUsers } from 'src/app/shared/models/detailUsers';
import { UsersService } from 'src/app/shared/services/users.service';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { CompaniesService } from 'src/app/shared/services/companies.service';
import { take } from 'rxjs/operators';
import { stringify } from 'querystring';
import { Level } from '../../shared/enums/level.enum';
import { element } from 'protractor';

@Component({
  selector: 'app-users-admin',
  templateUrl: './users-admin.component.html',
  styleUrls: ['./users-admin.component.scss']
})
export class UsersAdminComponent implements OnInit {
  _subscriptions: Subscription[] = [];
  usersList: any;
  udata: any;
  cdata: any;
  tempUserObj: any;
  tempLevel: number;
  userLevel = [];
  companies: Company[];
  companySelected: Company;
  companySelectedSave: Company;
  listCompanies: any[]=[];
  visibleCompany: boolean = false;
  disabledCompany: boolean = true;
  visibleCompanies: boolean = false;
  disabledCompanies: boolean = true;
  disabledLevel: boolean = true;
  id_companies_list: any[]=[];

  constructor(
    private usersService: UsersService,
    private companiesService: CompaniesService,
    private utilitiesService: UtilitiesService
    ) { }
    
    async ngOnInit() {
      this.udata = this.utilitiesService.getUserData();
      this.cdata = this.utilitiesService.getCompanyData();
      this.companySelected = new Company();
      
    switch (this.udata.level) {
      case Level.ihunterSuperUser:
      case Level.ihunterAdmin:
      case Level.ihunterReportes:
        this._subscriptions.push(
          this.companiesService.getCompanies().subscribe(companiesList => {
            console.log('<--------------------->',companiesList);
            this.companies = companiesList;
          })
        )
        this.userLevel = [
          { name: 'ihunter Admin', level: 1 },
          { name: 'ihunter Usuario', level: 2 },
          { name: 'ihunter Reportes', level: 3 },
          { name: 'Administrador', level: 4 },
          { name: 'Usuario', level: 5 },
          { name: 'Reportes', level: 6 },
          { name: 'Broker', level: 7 },
          { name: 'Cajero', level: 10 }
          
        ];    
        this._subscriptions.push(
          this.usersService.getAllUsers().subscribe(users => {
            this.usersList = users;
          })
        );
      break;
      case Level.CompanyAdmin:
      case Level.CompanyUser:
      case Level.CompanyReportes:
        this._subscriptions.push(
          this.companiesService.getCompanies().subscribe(companiesList => {
            console.log('<--------------------->',companiesList);
            this.companies = companiesList;
          })
        )
        this.disabledLevel = false;
        this.userLevel = [
          { name: 'Administrador', level: 4 },
          { name: 'Usuario', level: 5 },
          { name: 'Reportes', level: 6 }
        ];
        this._subscriptions.push(
          this.usersService.getCompanyAdminUsers(this.cdata.id).subscribe(users => {
            this.usersList = users;
          })
        );
      break;
      case Level.Broker:
        this.companies = this.udata.companyList ? this.udata.companyList : [];
        let companyIn = new Company();
        companyIn.id = this.cdata.id.trim();
        companyIn.companyName = this.cdata.companyName;
        this.companies.push(companyIn);
        this.userLevel = [
          { name: 'Administrador', level: 4 },
          { name: 'Usuario', level: 5 },
          { name: 'Reportes', level: 6 },
          { name: 'Broker', level: 7 }
        ];
        if (this.udata.companyList) {
          this.udata.companyList.forEach(company => {
            this.id_companies_list.push(company.id.trim());
          });
        }
        this.id_companies_list.push(this.cdata.id.trim());
        this._subscriptions.push(
          this.usersService.getBrokerUsers(this.id_companies_list).subscribe(users => {
            this.usersList = users;
            console.log('this.usersList',this.usersList);
          })
        );
      break;
      default:
        this._subscriptions.push(
          this.companiesService.getCompanies().subscribe(companiesList => {
            console.log('<--------------------->',companiesList);
            this.companies = companiesList;
          })
        )
      break;
    }
    
  }

  setEditedValue (valueChangedEventArg, cellInfo) {
    console.log('valueChangedEventArg.value',valueChangedEventArg.value);
    
    cellInfo.setValue(valueChangedEventArg.value);
  }
  changeCompaniesS(e){
    console.log('changeCompaniesS',e);
  }
  changeCompanie(e){
    let company = this.companies.filter(dispersion => dispersion.id == e.value);
    let companyInto = {
      id:'' ,
      companyName:''
    };
    companyInto.id=company[0].id;
    companyInto.companyName=company[0].companyName;
    this.listCompanies.push(companyInto);
  }

  async deleteCompanyList(event,indice){
    console.log('this.listCompanies antes de Delete',this.listCompanies);
    this.listCompanies = await this.listCompanies.filter(company => company.companyName != event.companyName);
    console.log('this.listCompanies con Delete',this.listCompanies);
  }
  onEditorPrepared(evt){

  }

  onInitNewRow(evt){
    switch (this.udata.level) {
      case Level.ihunterSuperUser:
      case Level.ihunterAdmin:
      case Level.ihunterReportes:
        this.disabledCompany = false;
        this.visibleCompany = true;
        this.disabledLevel = false;
        this.userLevel = [
          { name: 'ihunter Admin', level: 1 },
          { name: 'ihunter Usuario', level: 2 },
          { name: 'ihunter Reportes', level: 3 },
          { name: 'Administrador', level: 4 },
          { name: 'Usuario', level: 5 },
          { name: 'Reportes', level: 6 }
        ]  
      break;
      case Level.Broker:
        this.disabledCompany = false;
        this.visibleCompany = true;
        this.disabledLevel = false;
        this.userLevel = [
          { name: 'Administrador', level: 4 },
          { name: 'Usuario', level: 5 },
          { name: 'Reportes', level: 6 }
        ]
      break;
      default:
        
      break;
    }
    this.listCompanies = [];
  }
  onEditorPreparing(evt): void{
    if (evt.dataField === 'level') {
      evt.editorOptions.onValueChanged = (e: any) => {
        evt.setValue(e.value);
        if (e.value == 7) {
            this.visibleCompanies = true;
            this.disabledCompanies = false;
        }else{
            this.listCompanies = [];
            this.visibleCompanies = false;
            this.disabledCompanies = true;
        }
      }
    };
    if (evt.dataField === 'companyId') {
      evt.editorOptions.onValueChanged = (e: any) => {
        evt.setValue(e.value);
        this.companySelectedSave = this.companies.filter(dispersion => dispersion.id == e.value)[0];
        console.log('this.companySelectedSave',this.companySelectedSave);
        
      }
    };
  }
  onEditingStart(e){
    if (e.data.level == 7) {
      this.visibleCompanies = true;
      this.disabledCompanies = false;
    }else{
      this.visibleCompanies = false;
      this.disabledCompanies = true;
    }
    switch (this.udata.level) {
      case Level.ihunterSuperUser:
      case Level.ihunterAdmin:
      case Level.ihunterReportes:
        this.disabledCompany = false;
        this.visibleCompany = true;
        this.disabledLevel = false;
        this.userLevel = [
          { name: 'ihunter Admin', level: 1 },
          { name: 'ihunter Usuario', level: 2 },
          { name: 'ihunter Reportes', level: 3 },
          { name: 'Administrador', level: 4 },
          { name: 'Usuario', level: 5 },
          { name: 'Reportes', level: 6 },
          { name: 'Broker', level: 7 }
        ]  
      break;
      case Level.Broker:
        this.disabledCompany = false;
        this.visibleCompany = true;
        this.disabledLevel = false;
        if (e.data.level == 7) {
          this.disabledLevel = true;
          this.disabledCompany = true;
          this.disabledCompanies = true;
          this.userLevel = [
            { name: 'Administrador', level: 4 },
            { name: 'Usuario', level: 5 },
            { name: 'Reportes', level: 6 },
            { name: 'Broker', level: 7 }
          ]
        }else{
          this.disabledLevel = false;
          this.disabledCompany = false;
          this.disabledCompanies = false;
          this.userLevel = [
            { name: 'Administrador', level: 4 },
            { name: 'Usuario', level: 5 },
            { name: 'Reportes', level: 6 }
          ]
        }
      break;
      default:
      break;
    }
    this.companySelectedSave = this.companies.filter(comp => comp.id == e.data.companyId)[0];
    this.companySelected = new Company();
    this.listCompanies = e.data.companyList ? e.data.companyList: [];

  }

  onEditCanceled(e){
    switch (this.udata.level) {
      case Level.Broker:
        this.userLevel = [
          { name: 'Administrador', level: 4 },
          { name: 'Usuario', level: 5 },
          { name: 'Reportes', level: 6 },
          { name: 'Broker', level: 7 }
        ];
      break;
      default:
      break;
    }
  }

  checkLevel(e) {
    this.tempLevel = e;
  }

  updateUser(e) {
    console.log('ENTRO AL UPDATE',e.newData);
    
    const userData = e.newData;
    // userData.companyList = this.listCompanies;
    if (userData.companyId) {
      userData.companyName = this.companySelectedSave.companyName;
      userData.companyId = this.companySelectedSave.id;
    }
    userData.id = e.key;
    // if(this.listCompanies.length>0){
    //   userData.isBroker = true;
    //   userData.level = 7;
    // }else{
    //   userData.isBroker = false;
    // }
    this.usersService.updateUser(userData).pipe(take(1)).subscribe(user => {
      this.utilitiesService.notifyMe('Usuario actualizado', 'success');
    }, (error => {
      this.utilitiesService.notifyMe(error, 'error');
    })
    );
  }
  createUser(e) {
    console.log('ENTRO AL SAVE');
    
    const newUserData = e.data;
    if (this.udata.level <= Level.ihunterReportes || this.udata.level == Level.Broker) {
      newUserData.companyName = this.companySelectedSave.companyName;
      newUserData.companyId = this.companySelectedSave.id;
    }else{
      newUserData.companyName = this.cdata.companyName;
      newUserData.companyId = this.cdata.id;
    }
    newUserData.active = true;
    newUserData.belongsToProgram = false;
    newUserData.belongsToIhunterProgram = false;
    newUserData.dateCreated = this.utilitiesService.dateToNumber(new Date());
    // newUserData.level = 4;
    newUserData.birthDate = '1990-01-01';
    // newUserData.companyList = this.listCompanies;
    // if(this.listCompanies.length>0){
    //   newUserData.isBroker = true;
    //   newUserData.level = 7;
    // }
    // console.log('newUserData',newUserData);
    this.usersService.newUser(newUserData).pipe(take(1)).subscribe(e => {
      this.utilitiesService.notifyMe('Usuario agregado', 'success');
    }), (error => {
      this.utilitiesService.notifyMe(error, 'error');
    })
  }

  deleteData(e) { }

  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe);
  }

}
